import React, { useState } from 'react'
import styleLoading from './Loading.module.scss'

interface ILoadingProps {
  color?: string | ''
  size?: string | ''
}

export type LoadingProps = ILoadingProps

export const Loading = (props: LoadingProps): JSX.Element => {
  const [color, setColor] = useState(props.color || null)
  const [size, setSize] = useState(props.size || null)

  return (
        <div className={styleLoading._ + ' ' + (
          color === 'white'
            ? styleLoading._white
            : color === 'blue'
              ? styleLoading._blue
              : '')}
            style={{
              height: (size === 'small' ? 8 : size === 'medium' ? 24 : size === 'big' ? 32 : 56),
              width: (size === 'small' ? 8 : size === 'medium' ? 24 : size === 'big' ? 32 : 56)
            }} />
  )
}
